import React from "react";
import "./Skills.css";
import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaReact,
  FaGitAlt,
  FaMobileAlt,
  FaHandsHelping,
  FaLightbulb,
  FaSyncAlt,
  FaStar,
} from "react-icons/fa";

import { SiBootstrap, SiGithub, SiNetlify } from "react-icons/si";
import { VscVscode } from "react-icons/vsc";
import { TbRoute } from "react-icons/tb";
import { LuComponent } from "react-icons/lu";

const skillCategories = [
  {
    title: "Frontend",
    skills: [
      { name: "HTML5", icon: <FaHtml5 /> },
      { name: "CSS3", icon: <FaCss3Alt /> },
      { name: "JavaScript (ES6)", icon: <FaJs /> },
      { name: "React.js", icon: <FaReact /> },
      { name: "Bootstrap", icon: <SiBootstrap /> },
    ],
  },
  {
    title: "Tools",
    skills: [
      { name: "Git", icon: <FaGitAlt /> },
      { name: "GitHub", icon: <SiGithub /> },
      { name: "VS Code", icon: <VscVscode /> },
      { name: "Netlify", icon: <SiNetlify /> },
    ],
  },
 {
  title: "Concepts",
  skills: [
    { name: "Responsive Design", icon: <FaMobileAlt /> },
    { name: "React Hooks", icon: <LuComponent /> },
    { name: "React Router", icon: <TbRoute /> },
  ],
},
{
  title: "Soft Skills",
  skills: [
    { name: "Quick Learner", icon: <FaStar /> },
    { name: "Team Collaboration", icon: <FaHandsHelping /> },
    { name: "Problem Solving", icon: <FaLightbulb /> },
    { name: "Adaptability", icon: <FaSyncAlt /> },
    { name: "Self-Motivated", icon: <FaStar /> },
  ],
},
];

function Skills() {
  return (
    <section id="skills" className="skills">
      <h2 className="skills-title">Skills</h2>

      {skillCategories.map((category, index) => (
        <div key={index} className="category">
          <h3 className="category-title">{category.title}</h3>

          <div className="skills-grid">
            {category.skills.map((skill, i) => (
              <div className="skill-item" key={i}>
                <span className="skill-icon">{skill.icon}</span>
                <span>{skill.name}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}

export default Skills;